import { render, staticRenderFns } from "./CytologyResult.vue?vue&type=template&id=dc30ba0c&scoped=true&"
import script from "./CytologyResult.vue?vue&type=script&lang=js&"
export * from "./CytologyResult.vue?vue&type=script&lang=js&"
import style0 from "./CytologyResult.vue?vue&type=style&index=0&id=dc30ba0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc30ba0c",
  null
  
)

export default component.exports